import module from './module';

import IApiService from '#/interface/core/service/api-service';
import IApiAccountService, {
  ILogInResult,
} from '#/interface/core/service/api-account-service';
import { noop } from '#/utils/function';

module.factory('ApiAccountService', ApiAccountService);

function ApiAccountService(ApiService: IApiService, $rootScope: any): IApiAccountService {
  'ngInject';

  return {
    changePassword,
    resetPassword,
    resetPasswordNoAuth,
    requestToken,
    logout,
    unpretend,
    reauthenticate
  };

  function changePassword(password: string, token: string) {
    return ApiService.request('users/password', {
      method: 'PATCH',
      data: { password },
      headers: {
        Authorization: token
      }
    }).then(noop);
  }

  function resetPassword(email: string) {
    return ApiService.post('users/password', { email });
  }

  function resetPasswordNoAuth(email: string) {
    return ApiService.post('users/reset-password', { email });
  }

  function requestToken(email: string, password: string) {
    return ApiService.post<ILogInResult>('users/login', { email, password });
  }

  function logout() {
    $rootScope.$broadcast('user-logout');
    return ApiService.post('users/logout');
  }

  function unpretend() {
    return ApiService.post('users/pretender-logout');
  }

  function reauthenticate(password: string) {
    return ApiService.post<ILogInResult>('users/reauthenticate', { password });
  }
}
